import { Button, FileUpload, UseStepContext } from '@consigli/facade';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useWizardContext } from '../wizard-context';

interface DocumentsStepProps {
  context: UseStepContext;
}

export const DocumentsStep: FC<DocumentsStepProps> = ({ context }) => {
  const { t } = useTranslation();
  const {
    documentFiles,
    setDocumentFiles,
    // gisFiles,
    // setGisFiles,
  } = useWizardContext();
  const { next, previous, hasNext, hasPrevious } = context();

  const hasFiles = documentFiles.length > 0; // || gisFiles.length > 0;
  const canProceed = hasFiles;

  return (
    <div className="w-full">
      <p className="mt-4 mb-2 text-base font-semibold text-day-neutral-subtle">
        {t('package-creation.file-upload-header')}
      </p>
      <div>
        <p className="mb-1 text-base font-semibold text-day-neutral-subtle">
          {t('package-creation.upload-data-room-documents')}
        </p>
        <p className="mb-2 text-xs text-day-neutral-subtle">
          {t('package-creation.data-room-formats')}
        </p>
        <FileUpload
          files={documentFiles}
          setFiles={setDocumentFiles}
          dropAreaLabel={t('document-upload.drag-n-drop-here')}
          dropAreaClassName="h-48 w-full"
          fileButtonLabel={t('document-upload.browse-files')}
          folderButtonLabel={t('document-upload.browse-folders')}
          uploadListLabel={t('document-upload.files')}
          zeroByteFilesMessage={t('document-upload.file-zero-bytes')}
        />
      </div>

      {/* <div>
        <p className="mb-1 text-base font-semibold text-day-neutral-subtle">
          {t('package-creation.upload-gis-documents')}
        </p>
        <p className="mb-2 text-xs text-day-neutral-subtle">
          {t('package-creation.gis-formats')}
        </p>
        <FileUpload
          files={gisFiles}
          setFiles={setGisFiles}
          dropAreaLabel={t('document-upload.drag-n-drop-here')}
          dropAreaClassName="h-48 w-full"
          fileButtonLabel={t('document-upload.browse-files')}
          folderButtonLabel={t('document-upload.browse-folders')}
          uploadListLabel={t('document-upload.files')}
          zeroByteFilesMessage={t('document-upload.file-zero-bytes')}
        />
      </div> */}
      <div className="flex items-stretch gap-2 mt-6">
        {hasPrevious && (
          <Button secondary rounded onClick={previous} type="button">
            {t('package-creation.back')}
          </Button>
        )}
        {hasNext && (
          <Button primary rounded onClick={next} type="button" disabled={!canProceed}>
            {t('package-creation.next')}
          </Button>
        )}
      </div>
    </div>
  );
};
